<template>
  <nav aria-label="Page navigation">
  <ul class="pagination">
    <li :class="{'disabled' : page === 0}" >
      <a v-if='page !== 0' href="#" aria-label="Previous" @click.prevent.stop='prev()'><span aria-hidden="true">&laquo;</span></a>
      <span v-if='page === 0' ><span aria-hidden="true">&laquo;</span></span>
    </li>
    <li v-for='(pageItem,index) in pages' :key='`page-${index}`' :class="{'active' : ((pageItem - 1) === page) }"><a href="#" @click.prevent.stop='goTo(pageItem)'>{{pageItem}}</a></li>
    <li :class="{'disabled' : lastPage}">
      <a v-if='!lastPage' href="#" aria-label="Next" @click.prevent.stop='next()'><span aria-hidden="true">&raquo;</span></a>
      <span v-if='lastPage'><span aria-hidden="true">&raquo;</span></span>
    </li>
  </ul>
</nav>
</template>
<script>

import { getPages } from '../util/pagination-util'

export default {

  props: {
    count: Number,
    limit: Number,
    page: Number
  },

  computed: {
    lastPage () {
      const numberOfPages = this.getNumberOfPages()
      return numberOfPages === (this.page + 1) || numberOfPages === 0
    },
    pages () {
      const numberOfPages = this.getNumberOfPages()
      return getPages(numberOfPages, this.page + 1)
    }
  },

  methods: {

    getNumberOfPages () {
      return Math.ceil(this.count / this.limit)
    },

    goTo (page) {
      if (this.page === page - 1) {
        return false
      }
      this.$emit('changePage', page - 1)
      return false
    },

    next () {
      return this.goTo(this.page + 2)
    },

    prev () {
      return this.goTo(this.page)
    }
  }

}
</script>
<style scoped>
    .pagination {
        justify-content: center;
    }
</style>

